import { Colors } from "components/common/Colors";
import Icon from "components/Icons/Icon";
import { t } from "i18n/index";
import { useMarketingLang } from "i18n/useMarketingLang";
import "./RelatedFeaturesStrip.scss";
import { getChromeTranslations } from "../marketing/i18n/pages/chrome";

export interface RelatedFeature {
	label: string;
	href: string;
	icon: string;
	color: string;
}

interface RelatedFeaturesStripProps {
	features: RelatedFeature[];
	heading?: string;
}

const RelatedFeaturesStrip = ({ features, heading }: RelatedFeaturesStripProps) => {
	// An explicitly passed `heading` always wins — only the default falls back to the visitor's
	// locale, resolved via `useMarketingLang()`/chrome translations the same way Footer.tsx does.
	// Called unconditionally, before the early return below, so the hook order never varies.
	const lang = useMarketingLang();
	const translations = getChromeTranslations(lang);
	if (!features || features.length === 0) return null;
	const resolvedHeading = heading ?? t(translations, "featureChrome.exploreMoreFeatures", "Explore more Stippl features");
	return (
		<div className="related-features-strip">
			<p className="related-features-strip__heading">{resolvedHeading}</p>
			<div className="related-features-strip__cards">
				{features.map((f) => (
					<a key={f.href} href={f.href} className={`related-features-card related-features-card--${f.color}`}>
						<span className="related-features-card__icon">
							<Icon
								//@ts-ignore
								name={f.icon}
								fill={Colors?.[f.color]}
							/>
						</span>
						<span className="related-features-card__label">{f.label}</span>
					</a>
				))}
			</div>
		</div>
	);
};

export default RelatedFeaturesStrip;
